import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

export type DriverTabId = 'home' | 'map' | 'profile';

@Component({
    selector: 'app-driver-tab-bar',
    standalone: true,
    imports: [CommonModule, MatIconModule, RouterLink],
    templateUrl: './driver-tab-bar.component.html',
})
export class DriverTabBarComponent {
    @Input() activeTab: DriverTabId = 'home';

    readonly tabs: { id: DriverTabId; label: string; icon: string; route: string }[] = [
        { id: 'home', label: 'Início', icon: 'heroicons_outline:home', route: '/driver/home' },
        { id: 'map', label: 'Mapa', icon: 'heroicons_outline:map', route: '/driver/map' },
        { id: 'profile', label: 'Perfil', icon: 'heroicons_outline:user', route: '/driver/profile' },
    ];
}
